import React, { useEffect, useRef } from 'react'
import JockerIntro from '../components/JockerIntro'
import Famille from '../components/Famille'
import Exclusif from '../components/Exclusif'
import Faq from '../components/Faq'
import FooterPage from '../components/FooterPage'

const JokerClub = () => {
  const topRef = useRef<HTMLDivElement>(null)
  
  useEffect(() =>{
    if(topRef){
      window.scrollTo(0,0)
    }
  },[])

  return (
    <div>
    <JockerIntro/>
    <Famille/>
    <Exclusif/>
    <Faq/>
    <FooterPage/>
    </div>
  )
}

export default JokerClub